import { InsuredFiles } from "@qw/insured";
import { Navigate, type RouteObject, useLocation } from "react-router";
import { INBOX_AGENCY_SEGMENT, INBOX_AGENT_SEGMENT } from "@/providers/inbox-scope";
import { Active } from "./active/active";
import { MiniApp } from "./mini-app";

const InboxRootRedirect = () => {
  const { search } = useLocation();

  return <Navigate to={{ pathname: "/inbox", search }} replace />;
};

// The one child every scoped shell renders, shared rather than repeated so "a set-scoped route is
// the insured route minus the insured" is the structure and not just a comment.
const activeRoute: RouteObject = {
  index: true,
  element: <Active />,
};

export const miniAppRoutes = (): RouteObject[] => [
  {
    path: "files",
    element: <InboxRootRedirect />,
  },
  // A scope with no id is not a scope. Each gets a route of its own for the same reason `files`
  // does, and the reason is not the redirect: `:insuredId?` is a bare optional param, so without a
  // literal route ahead of it `/inbox/agents` binds `insuredId` to the string `"agents"` — which
  // `inbox-filter-provider`, `insured-provider`, `chat-column` and the Book's `aria-current` all
  // read raw and would go looking for an insured by that name.
  {
    path: INBOX_AGENT_SEGMENT,
    element: <InboxRootRedirect />,
  },
  {
    path: INBOX_AGENCY_SEGMENT,
    element: <InboxRootRedirect />,
  },
  // Declared *before* `:insuredId?`, which would otherwise swallow the `agents` and `agencies`
  // segments. The same element tree as the insured route minus the insured, so the rail describes
  // whatever conversation the broker opens out of the scope's mail, exactly as it does at the bare
  // inbox root. No `files` child: files hang off an insured, and the Files tab builds its target
  // from the selected insured rather than from this route.
  {
    path: `${INBOX_AGENT_SEGMENT}/:agentId`,
    element: <MiniApp />,
    children: [activeRoute],
  },
  {
    path: `${INBOX_AGENCY_SEGMENT}/:agencyId`,
    element: <MiniApp />,
    children: [activeRoute],
  },
  {
    path: ":insuredId?",
    element: <MiniApp />,
    children: [
      activeRoute,
      {
        path: "files",
        element: <InsuredFiles />,
      },
    ],
  },
];
